export const NEW_BLOCK_PLACEHOLDER_ID = 'new-block-placeholder'
